var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.24609V13.9999C1 14.5522 1.44772 14.9999 2 14.9999H15.5077C16.06 14.9999 16.5077 14.5522 16.5077 13.9999V7.89225",
    stroke: "#728095",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25391 1C9.25391 0.723858 9.03005 0.5 8.75391 0.5C8.47776 0.5 8.25391 0.723858 8.25391 1H9.25391ZM8.40035 9.96894C8.59561 10.1642 8.9122 10.1642 9.10746 9.96894L12.2894 6.78696C12.4847 6.5917 12.4847 6.27511 12.2894 6.07985C12.0942 5.88459 11.7776 5.88459 11.5823 6.07985L8.75391 8.90828L5.92548 6.07985C5.73022 5.88459 5.41363 5.88459 5.21837 6.07985C5.02311 6.27511 5.02311 6.5917 5.21837 6.78696L8.40035 9.96894ZM8.25391 1V9.61539H9.25391V1H8.25391Z",
    fill: "#728095"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadNew);
export default __webpack_public_path__ + "static/media/downloadNew.3cf17c6c862323b2788bf482783776c0.svg";
export { ForwardRef as ReactComponent };